import Form from 'components/Form';
import { IPatientInfo } from 'apis/admin/type';

import RowContainer from './RowContainer';
import RowContent from './RowContent';

interface Props {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const CommonPatientInfo = (props: Props) => {
  const {
    patientInfo: {
      patient_id,
      name,
      age,
      gender,
      ward,
      room,
      admin_hod,
      admin_pod,
      department,
      disease_main,
      main_doctor,
    },
    nurseName,
  } = props;

  const infos = [
    { title: 'Өвчтөний нэр', value: name },
    { title: 'Бүртгэлийн №', value: patient_id },
    { title: 'Нас', value: age },
    { title: 'Хүйс', value: gender },
    { title: 'Өрөө', value: ward },
    { title: 'Өрөөний дугаар', value: room },
    { title: 'HOD', value: admin_hod },
    { title: 'POD', value: admin_pod },
    { title: 'Тасаг', value: department },
    { title: 'Онош', value: disease_main.disease_eng },
    { title: 'Эмч', value: main_doctor },
    { title: 'Сувилагч', value: nurseName },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === 'Gender' ? (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiRadioGroup
              i18nKey="GENDER"
              values={[1, 2]}
              value={Number(value)}
              defaultValue={Number(value)}
            />
          </RowContent>
        ) : (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiTextField value={value} InputProps={{ readOnly: true }} />
          </RowContent>
        )
      )}
    </RowContainer>
  );
};

export default CommonPatientInfo;
